// extracted by mini-css-extract-plugin
export default {"input":"text-area_input","inputError":"text-area_inputError","description":"text-area_description","wrapper":"text-area_wrapper","characterCount":"text-area_characterCount"};